import { ReactElement } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import { RegisterOptions } from "react-hook-form";

export const BirthdayField = ({
  files,
  setFiles,
  register,
  errors,
}: {
  files: any;
  setFiles: any;
  register: (ref: string, options: RegisterOptions) => any;
  errors: Record<string, any>;
}): ReactElement => {
  registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileValidateSize,
    FilePondPluginFileValidateType,
    FilePondPluginFileEncode
  );
  return (
    <>
      <div className="field">
        <label>
          <span className="label">身分証明書</span>
          <FilePond
            // @ts-ignore
            accept={"image/*"}
            acceptedFileTypes={["image/*"]}
            maxFileSize={"2MB"}
            labelMaxFileSizeExceeded="ファイルサイズは2MBまでです。"
            labelFileTypeNotAllowed="画像ファイル以外はアップロードできません。"
            files={files}
            onupdatefiles={setFiles}
            labelIdle='ここにファイルをドラッグ・アンド・ドロップ もしくは <span class="filepond--label-action"> 選択する </span>'
          />
          <span className="sub">学生証・学生定期・マイナンバーカード・保険証など</span>
          <br />
          <span className="sub">最大2MBまで、.png .jpgのみ</span>
        </label>
      </div>
      <div className="field">
        <label>
          <span className="label">生年月日</span>
          <input type="date" {...register("birth_date", { required: true })} />
          {errors.birth_date && <span className="sub red">生年月日を入力してください。</span>}
        </label>
      </div>
    </>
  );
};
